import Ajax from '@/lib/ajax'
import getUrlConfig from '@/lib/urlConfig'

const api = getUrlConfig.api
const apiSEA = getUrlConfig.apiSEA

const checkApi = getUrlConfig.checkApi
const checkApiSEA = getUrlConfig.checkApiSEA

/**
 * 获取 信息公开列表
 * @param {object} data
 */
export const getInfoDisclosureListService = (data) =>
  Ajax.post(api + '/getInfoDisclosureListService', data);
/**
 * 信息公开存储
 * @param {object} data
 */
export const saveInfoDisclosureService = (data) =>
  Ajax.post(api + '/saveInfoDisclosureService', data);
/**
 * 信息公开pdf下载数据
 * @param {object} data
 */
export const getPageFileDataService = (data) =>
  Ajax.post(api + '/getPageFileDataService', data);
/**
 * 信息公开排放单位列表
 * @param {object} data
 */
export const getKeyEmissionUnitListService = (data) =>
  Ajax.post(api + '/getKeyEmissionUnitListService', data);

/**
 * 删除 信息公开列表
 * @param {object} data
 */
export const deleteInfoDisclosureService = (data) =>
  Ajax.post(api + '/deleteInfoDisclosureService', data);


// ------------------SEA加密

/**
 * 137.	信息公开排放单位列表
 * @param {object} data
 */
export const getKeyEmissionUnitListServiceSEA = (data) =>
  Ajax.post(apiSEA + '/getKeyEmissionUnitListService', data, 'SEA');

/**
 * 获取 信息公开列表
 * @param {object} data
 */
export const getInfoDisclosureListServiceSEA = (data) =>
  Ajax.post(apiSEA + '/getInfoDisclosureListService', data, 'SEA');

  /**
 * 获取 省市县
 * @param {object} data
 */
export const getAreaNewSEA = (data) =>
Ajax.post(apiSEA + '/getAreaNew', data, 'SEA');



/**
 *核查端信息公开 - 公开端获取已公开的技术服务机构列表：
 * @param {object} data
 */
export const getCheckOrgInfoListServiceSEA = (data) =>
  Ajax.post(checkApiSEA + '/getCheckOrgInfoListService', data, "SEA");
/**
 *核查端信息公开 - 公开端获取技术服务机构的公开记录：
 * @param {object} data
 */
export const getCheckOrgInfoDisclosureRecordListSEA = (data) =>
  Ajax.post(checkApiSEA + '/getCheckOrgInfoDisclosureRecordList', data, "SEA");

/* 公开端-预览 技术服务机构附件列表
 * @param {object} data
 */
export const getOpenInfoFileListSEA = (data) =>
  Ajax.post(checkApiSEA + '/getOpenInfoFileList', data, "SEA");

/* 公开端-下载 核查端信息公开 - pdf
 * @param {object} data
 */
export const downloadPublishInfoPdfFileService = (data) =>
  Ajax.downloadFile(checkApi + '/downloadPublishInfoPdfFileService', data, "check");